import { EditPage, EditPageTextField, EditPageCheckbox, EditPagePanel, EditPageTextArea } from './../../../common/EditPage';
import { create, getOne } from './../../../common/v4/BackendProvider';
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';

const AiSpeechStylesCreate = () => {
    const [data, setData] = useState({});
    const [metadata, setMetadata] = useState({});
    const navigate = useNavigate();

    useEffect(() => {
        getOne('/admin/ai/speech-styles/', 'new').then(response => {
            setMetadata(response.data.metadata);
        });
    }, []);

    const handleSave = () => {
        create('/admin/ai/speech-styles', {data: data}).then(response => {
            toast.success("Speech Style created successfully", {});
            navigate('/ai/speech-styles');
        }).catch(error => {
            toast.error("Error creating Speech Style: " + error.message, {});
        });
    }

    const handleCancel = () => {
        navigate('/ai/speech-styles');
    }

    const onChange = (id, value) => {
        setData({ ...data, [id]: value });
    }
    
    return (
        <div>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                closeOnClick={true}
                pauseOnHover={true}
                draggable={true}
                progress="undefined"
            />
            <EditPage handleSave={handleSave} handleCancel={handleCancel} title="Create Speech Style">
                <EditPagePanel className="col-lg-8">
                    <EditPageTextField label="Name" id="name" onChange={onChange} value={data?.name} />
                    <EditPageTextArea label="Instructions" id="instructions" onChange={onChange} value={data?.instructions} rows={40} />
                </EditPagePanel>
            </EditPage>
        </div>
    );
};

export default AiSpeechStylesCreate;